module.exports = __webpack_public_path__ + "img/cap1.646d8c37.png";